import { FC, useMemo } from "react";
import { Table } from "@vilocnv/allsetra-core";
import { TAG_POSITION_DATE_COLUMNS } from "app/data/constants";
import TagPositionExpendableRowCard from "../TagPositionExpendableRowCard/TagPositionExpendableRowCard";
import { useTranslation } from "react-i18next";

interface TagPositionDateRowCardProps {
  data: any;
}

const TagPositionDateRowCard: FC<TagPositionDateRowCardProps> = ({ data }) => {
  const { t } = useTranslation(["translation", "tableHeadingsTranslation"]);

  const tableColumns = useMemo(() => TAG_POSITION_DATE_COLUMNS(t), [t]);

  const customStyles = {
    headRow: {
      style: {
        ".sc-fqkvVR.sc-fHjqPf.dKzMcW.cSyyNR": {
          display: "none"
        }
      }
    }
  };

  return (
    <Table
      data={data.details}
      columns={tableColumns}
      expandableRows
      expandOnRowClicked
      pagination={false}
      expandableRowsComponent={TagPositionExpendableRowCard}
      nestedRowPadding="16px"
      customStyles={customStyles}
      translator={t}
    />
  );
};

export default TagPositionDateRowCard;
